import React, {useMemo} from 'react'
import { expandReference, deadlineObjectChecker } from '../../lib/utils';
import {ViewLabelValueField,VisDiv } from '../../components';
import {useStateContext} from '../../context/StateContext';
import {DataScadenzaCollaudoQuinquennaleCollaudoAnnuale} from '../../lib/ScadenzeData'


/**
 * Component to display deadlines for a device with Collaudo Quinquennale, Collaudo Annuale and Scadenza deadlines
 * #deadlines
 * @param {object} device - The device object
 * @param {object} deviceTemplate - The device template object
 * @param {object} registerTemplate - The register template object
 *  
 * @returns {JSX.Element} A JSX element displaying the deadlines
 */
const ScadenzaCollaudoQuinquennaleCollaudoAnnuale = ({device, deviceTemplate, registerTemplate}) => {

    const testing = false
    const data = useMemo(() => (DataScadenzaCollaudoQuinquennaleCollaudoAnnuale(device, deviceTemplate, registerTemplate)),[device,deviceTemplate, registerTemplate]);
    const {expiry, quinquennialTest, yearlyTest, maintenanceTasksList} = data
    const exists = [!!expiry?.date, !!quinquennialTest?.date, !!yearlyTest?.date].some?.(x=>x==true)
    const testFunction = () => {
        //console.log(DataScadenzaCollaudoQuinquennaleCollaudoAnnuale(device, deviceTemplate, registerTemplate))
       console.log("s-elrkvfjm",{data,txt: !isNaN(quinquennialTest?.date)})
    }

        return (
            <div>
                <VisDiv rules={[testing]}><button onClick={()=>{testFunction()}}>Test deadlines</button></VisDiv>
                <VisDiv rules={[yearlyTest?.date]}>
                    <ViewLabelValueField
                        label={yearlyTest?.label}
                        value={ deadlineObjectChecker(yearlyTest?.dateObject, false, true)?.date}
                        highlight={ deadlineObjectChecker(yearlyTest?.dateObject, false, true)?.color}
                    />
                </VisDiv>
                <VisDiv rules={[quinquennialTest?.date]}>
                    <ViewLabelValueField
                        label={quinquennialTest?.label}
                        value={ deadlineObjectChecker(quinquennialTest?.dateObject, false, true)?.date}
                        highlight={ deadlineObjectChecker(quinquennialTest?.dateObject, false, true)?.color}

                    />
                </VisDiv>
                <VisDiv rules={[expiry?.date]}>
                    <ViewLabelValueField
                        label={expiry.label}
                        value={ deadlineObjectChecker(expiry?.dateObject)?.date}
                        highlight={ deadlineObjectChecker(expiry?.dateObject)?.color}
                    />
                </VisDiv>
            </div>
        )
    

}

export default ScadenzaCollaudoQuinquennaleCollaudoAnnuale
